import React, { useState } from 'react'
import { GlgTooltip } from '../../../shared/components'
import { GGButton } from '../../../shared/new_components/GGButton'
import PropTypes from 'prop-types'

const CopyLink = ({ linkUrl }) => {
  const [ isClicked, setIsClicked ] = useState(false)

  const tooltipText = isClicked ? window.I18n.t('gg_golf_hub.dashboard.copy_link_success') : window.I18n.t('gg_golf_hub.dashboard.copy_link_tooltip')

  const handleOnClick = () => {
    navigator.clipboard.writeText(linkUrl)
    .then(() => {
      setIsClicked(true)
      setTimeout(() => setIsClicked(false), 1500)
    })
    .catch(() => {
      setIsClicked(false)
    })
  }

  return (
    <GlgTooltip tooltip={tooltipText} placement='bottom'>
      <span>
        <GGButton variant='ghost' icon={isClicked ? 'check' : 'copy-o'} onClick={handleOnClick} />
      </span>
    </GlgTooltip>
  )
}

CopyLink.propTypes = {
  linkUrl: PropTypes.string,
}

export default CopyLink
